<div
  [ngClass]="{
    warning: type === 'warn' || 'warn-soft',
    info: type === 'info',
    border: type !== 'warn-soft'
  }"
  class="container"
>
  <div class="message">
    <mat-icon class="icon">
      {{ type === 'warn' ? 'warning' : 'info outline' }}
    </mat-icon>
    <span class="message--title" *ngIf="statusTitle">{{ statusTitle }}</span>
    <span [ngClass]="{ noTitle: !statusTitle }">{{ statusText }}</span>
  </div>
  <div class="action" *ngIf="actionTitle && actionCallback">
    <a (click)="actionCallback()">{{ actionTitle }}</a>
  </div>
</div>
